import React, { useContext } from 'react';
import { noop } from 'utils/noop';
import { usePoorStandingContextController } from 'controllers/PoorStanding/PoorStanding.controller';

export type PoorStandingContextType = {
    isPoorStandingVisible: boolean;
    showPoorStanding: (newState: boolean) => void;
};

export const defaultPoorStandingContext = {
    isPoorStandingVisible: false,
    showPoorStanding: noop,
};

export const PoorStandingContext = React.createContext<PoorStandingContextType>(
    defaultPoorStandingContext,
);

export const usePoorStandingContext = (): PoorStandingContextType =>
    useContext(PoorStandingContext);

export const PoorStandingProvider = ({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement => {
    const context = usePoorStandingContextController();

    return (
        <PoorStandingContext.Provider value={context}>
            {children}
        </PoorStandingContext.Provider>
    );
};

export default PoorStandingProvider;
